import { WidgetType } from 'shared/widgets/utils';

import { createNewFillInTheBlanksQuestionData } from './create';
import { manifestLocales } from './manifest.locales';
import FillInTheBlanksEn from './resources/en/fitb-question.svg';
import FillInTheBlanksHe from './resources/he/fitb-question.svg';
import { QuestionsFill } from '@/icons/QuestionsFill';
import { ManifestType } from '@/types/ManifestType';

export const Manifest: ManifestType = {
  name: WidgetType.FillInTheBlanksQuestion,
  previewGroups: [
    {
      id: 'fillInTheBlanksQuestion',
      divider: {
        icon: QuestionsFill,
        title: 'fillInTheBlanksQuestion'
      },
      previews: [
        {
          name: 'fillInTheBlanksQuestionPreview',
          previewImage: {
            paths: {
              en: FillInTheBlanksEn,
              he: FillInTheBlanksHe
            },
            size: {
              width: 140,
              height: 122
            },
            alt: { ...manifestLocales.fillInTheBlanksQuestion.previewFillInTheBlanksQuestionAlt }
          },
          dimensions: {
            width: 1180,
            height: 'auto'
          },
          initializeProps: createNewFillInTheBlanksQuestionData
        }
      ]
    }
  ],
  additionalData: {
    constraints: {
      minHeight: 48,
      minWidth: 100
    }
  }
};
